// https://vuex.vuejs.org/en/actions.html

import NewApiService from "@/utils/new.api.service";

export default {
  add(context, params) {
    context.commit("set_loading");
    return new Promise(resolve => {
      NewApiService.post(`clients/${params.model.clientId}/addresses`, params.model)
        .then(({ data }) => {
          context.commit("unset_loading");
          resolve(data);
        })
        .catch(({ response }) => {
          context.commit("set_error", response.data.errors);
        });
    });
  },

  update(context, params) {
    context.commit("set_loading");
    return new Promise(resolve => {
      NewApiService.put(`clients/${params.model.clientId}/addresses/${params.model.id}`, params.model)
        .then(({ data }) => {
          context.commit("unset_loading");
          resolve(data);
        })
        .catch(({ response }) => {
          context.commit("set_error", response.data.errors);
        });
    });
  },

  markAsDefault(context, params) {
    context.commit("set_loading");
    return new Promise(resolve => {
      NewApiService.put(`clients/${params.clientId}/addresses/${params.id}/default`, params)
        .then(({ data }) => {
          context.commit("unset_loading");
          resolve(data);
        })
        .catch(({ response }) => {
          context.commit("set_error", response.data.errors);
        });
    });
  },

  get(context, params) {
    context.commit("set_loading");

    const filter = params.type ? {typeId: params.type} : null

    return new Promise((resolve, reject) => {
      NewApiService.get(`clients/${params.id}/addresses`, {
        filter
      } )
        .then(({ data }) => {
          context.commit("unset_loading");
          resolve(data);
        })
        .catch(({ response }) => {
          reject(response)
        });
    });
  },
  delete(context, params) {
    context.commit("set_loading");
    return new Promise(resolve => {
      NewApiService.delete(`clients/${params.model.clientId}/addresses/${params.model.id}`)
        .then(({ data }) => {
          context.commit("unset_loading");
          resolve(data);
        })
        .catch(({ response }) => {
          context.commit("set_error", response.data.errors);
        });
    });
  }
};
